(ns teamoesterreich.admin-mode.lebensretter.detail.training-documents-part

  (:require [clojure.string]
            [reagent-material-ui.components :as mui]
            [reagent-material-ui.icons.cloud-upload :refer [cloud-upload]]
            [reagent.core :as r]
            [teamoesterreich.setup :refer [USER_DOCUMENT_TYPES]]
            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.admin-mode.data.user :as d-user]
            [teamoesterreich.element.backend-file :as backend-file]
            [teamoesterreich.util.helper :as h]

            [teamoesterreich.util.log :as log]

            ))







(defn file-upload [!actual-user files userDokument-type & [on-finished-fn]]
  (when-let [file (.item files 0)]
    (log/out "got file" files)
    (let [fr (js/FileReader.)]
      (set! (.-onload fr)
            (fn [event]
              (log/out "read file" event (.. event -target -result))
              (d-user/>userDocument-upload (:user-uuid @!actual-user)
                                           userDokument-type
                                           {:buffer       (.. event -target -result)
                                            :file-name    (.-name file)
                                            :content-type (.-type file)
                                            :on-finished  (fn [url]
                                                            (log/out "got back URL" url)
                                                            (on-finished-fn url)
                                                            )})
              ))
      (.readAsArrayBuffer fr file))))


(defn select-type [!documentType]

  [mui/select
   {:style    {:width "300px"}
    :value    (or @!documentType "other")
    :onChange (fn [e]
                (js/console.log "Change type  -> " (h/event-value e))
                (reset! !documentType (h/event-value e)))
    }
   [mui/menu-item {:key "identification" :value "identification"} "Ausweis"]
   [mui/menu-item {:key "lebensretter-qualification" :value "lebensretter-qualification"} "Lebensretter Qualifikation"]
   [mui/menu-item {:key "selfDeclaration" :value "selfDeclaration"} "Selbsterklärung"]
   [mui/menu-item {:key "other" :value "other"} "Sonstiges"]
   ])

(defn upload-block [!actual-user]
  (let [!documentType (r/atom "other")
        !uploading (r/atom false)]
    (fn []
      (when true
        (fn []
          (if @!uploading
            [mui/card-content
             "Datei upload .... " [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 20}]
             ]
            [mui/card-content

             [select-type !documentType]
             [mui/button {:size      "small" :color "secondary"
                          :component "label"
                          :endIcon   (r/as-element [cloud-upload])
                          }
              "Dokument Hochladen"
              [:input {:type     "file" :hidden "hidden"
                       :disabled (if @!documentType false true)
                       :endIcon  (r/as-element [cloud-upload])
                       :onChange (fn [e]
                                   (log/debug "Upload document:: " (:user-uuid @!actual-user) (.item e.target.files 0))
                                   (reset! !uploading true)
                                   (.preventDefault e)
                                   (.stopPropagation e)
                                   (file-upload !actual-user e.target.files @!documentType
                                                (fn []
                                                  (d-user/actual-user-invalidate !actual-user)
                                                  (reset! !uploading false)))
                                   )
                       }]
              ]
             ])
          )))))






(defn document-tile [document !enlarge]
  (let [{:keys [userDocument-type userDocument-fileName userDocument-path userDocument-since]} document]
    [mui/grid {:item    true
               :style   {:width "120px" :height "160px" :overflow "hidden"
                         }
               :onClick #(reset! !enlarge userDocument-path)
               }

     [backend-file/img {:hash             userDocument-path
                               :preview? true
                               :style    {:height "100px" :width "100px" :objectFit "contain"} :alt "Ansicht"}]

     [:div {:style {:fontSize "11px" :overflow "hidden" :padding "0 5px 0 5px"}}
      [:span {} (h/date-ger userDocument-since)]
      [:br]
      [:span {:style {:color "blue"}} (or (get USER_DOCUMENT_TYPES userDocument-type) (str "? " userDocument-type))]
      [:br]
      [:span {} (or userDocument-fileName userDocument-path)]

      ]]))





(defn unused-training-documents [!enlarge !actual-user]

  [mui/grid {:container true :item false :style {:margin "0 20px 0 20px"}}

   (doall (for [doc (sort-by :userDocument-since
                             (filter (fn [d] (and (:userDocument-active d)
                                                  (not (:userDocument-isSelfExplain d))
                                                  (not (:userDocument-isIdentity d))
                                                  ))
                                     (:user-userDocument @!actual-user)))]
            ^{:key (str "userDocument-" (:userDocument-uuid doc))}
            [document-tile doc !enlarge]))

   ]
  )















